import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    fontFamily: 'Times-Roman',
    backgroundColor: '#fff',
    lineHeight: 1.5,
  },
  title: {
    fontSize: 20,
    textAlign: 'center',
    marginBottom: 24,
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  section: {
    marginBottom: 20,
    paddingBottom: 10,
    borderBottom: '1pt solid #000',
  },
  label: {
    fontWeight: 'bold',
  },
  fieldGroup: {
    marginBottom: 8,
  },
  signatureBlock: {
    marginTop: 24,
    borderTop: '1pt solid #000',
    paddingTop: 10,
  },
});

const Field = ({ label, value }) => (
  <View style={styles.fieldGroup}>
    <Text>
      <Text style={styles.label}>{label}:</Text> {value || '________________________'}
    </Text>
  </View>
);

const formatRate = (rateObj) =>
  `Per Hour: $${rateObj?.hour || '0'} | Per Week: $${rateObj?.week || '0'} | Annual: $${rateObj?.annual || '0'}`;

const formatCheckboxes = (obj) =>
  Object.entries(obj || {})
    .filter(([_, val]) => val)
    .map(([key]) => `☑ ${key.replace(/([A-Z])/g, ' $1')}`)
    .join(', ') || '☐ None selected';

const ChangeOfStatusPDF = ({ formData }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.title}>Employee Change Of Status Report</Text>

      <View style={styles.section}>
        <Field label="Employee Name" value={formData.employeeName} />
        <Field label="Pay ID" value={formData.payId} />
      </View>

      <View style={styles.section}>
        <Text style={styles.label}>Change in Pay Rate</Text>
        <Field label="Effective Date" value={formData.effectiveDate} />
        <Field label="Current Pay Rate" value={formatRate(formData.currentPayRate)} />
        <Field label="New Pay Rate" value={formatRate(formData.newPayRate)} />
        <Field label="Reason for Change" value={formData.reasonForPayChange} />
      </View>

      <View style={styles.section}>
        <Text style={styles.label}>Change in Job Status</Text>
        <Field label="Effective Date" value={formData.statusEffectiveDate} />
        <Field label="Division" value={formData.division} />
        <Field label="State" value={formData.state} />
        <Field label="Employment Classification" value={formatCheckboxes(formData.classification)} />
        <Field label="Status Change Type" value={formatCheckboxes(formData.statusChange)} />
        <Field label="Vehicle Allowance" value={`$${formData.statusChange?.vehicleAllowance || '0'}`} />
        <Field label="Cell Allowance" value={`$${formData.statusChange?.cellAllowance || '0'}`} />
        <Field label="Vacation Days" value={formData.vacationDays} />
        <Field label="Reason for Change" value={formData.jobChangeReason} />
        <Field label="Return to Work Date" value={formData.layoff?.returnDate} />
        <Field label="Layoff/Leave Status" value={formatCheckboxes(formData.layoff)} />
      </View>

      <View style={styles.section}>
        <Text style={styles.label}>Change of Personal Information</Text>
        <Field label="New Name" value={formData.personalChange?.newName} />
        <Field label="New Address" value={formData.personalChange?.newAddress} />
        <Field label="New Phone #" value={formData.personalChange?.newPhone} />
        <Field label="Emergency Contact (Name & Relation)" value={formData.personalChange?.emergencyContact} />
        <Field label="Phone (W)" value={formData.personalChange?.emergencyPhoneW} />
        <Field label="Phone (H)" value={formData.personalChange?.emergencyPhoneH} />
        <Field label="Cell" value={formData.personalChange?.emergencyPhoneCell} />
      </View>

      <View style={styles.section}>
        <Text style={styles.label}>Employee Termination</Text>
        <Field label="Last Work Date" value={formData.termination?.lastWorkDate} />
        <Field label="Rehire Eligible?" value={formData.termination?.rehire} />
        <Field label="Termination Reason(s)" value={(formData.termination?.reason || []).map(reason => `☑ ${reason}`).join(', ') || '☐ None'} />
        <Field label="Other Reason" value={formData.termination?.otherReason} />
        <Field label="Returned Assets" value={formData.termination?.companyAssets?.returned || 'None'} />
        <Field label="Did Not Return Assets" value={formData.termination?.companyAssets?.notReturned || 'None'} />
        <Field label="Comments" value={formData.termination?.comments} />
      </View>

      <View style={styles.signatureBlock}>
        <Field label="Supervisor Name" value={formData.supervisor?.name} />
        <Text style={styles.label}>Supervisor Signature:</Text>
           {formData.supervisor?.signature ? (
              <Image src={formData.supervisor.signature} style={{ width: 200, height: 75, marginBottom: 10 }} />
               ) : (
              <Text>N/A</Text>
            )}

        <Field label="Date" value={formData.supervisor?.date} />
      </View>

      <View style={styles.signatureBlock}>
        <Field label="Date Filed" value={formData.hrDept?.dateFiled} />
      </View>
    </Page>
  </Document>
);

export default ChangeOfStatusPDF;
